import { ConsoleLogger } from "./consoleLogger";

export * from "./consoleLogger";
export * from "./types";

export const logger = new ConsoleLogger();
